﻿<script>
  import { link } from "svelte-routing";
  import { getContext } from "svelte";
  import { usersStore } from "./store/users.js";
  import * as util from "./js/util.js";

  const { open } = getContext("modal");
  $: systemInfo = $usersStore.systemInfo;

  function hasAnyOfRoles(userRoles, allowedRolesStr) {
    let allowedRoles = allowedRolesStr.split(",");
    return allowedRoles.filter((ar) => userRoles.includes(ar)).length > 0;
  }

  let navActive = false;
  let headerClass = "unpin";
  let y = 0;
  let lastY = 0;
  let lastDirection = "up";

  function changeClass(y) {
    let result = headerClass;
    const scrollDirection = lastY - y < 0 && y > 40 ? "down" : "up";
    const changedDirection = scrollDirection !== lastDirection;
    if (changedDirection) {
      result = scrollDirection === "up" ? "unpin" : "pin";
      lastDirection = scrollDirection;
    }
    lastY = y;
    return result;
  }
  $: headerClass = changeClass(y);
  async function logout() {
    await usersStore.logout();
    showLoginScreen();
  }
</script>

<nav
  class="site-header sticky-top p-3 header-bar {headerClass}"
  class:open={navActive}
>
  <div class="row">
    <a class="col-1" id="logo" href="/app/countries" use:link>
      <div><img alt="logo" class="logo" src="/img/logo.svg" /></div>
    </a>

    <div class="col-11 text-right" style="padding-right:80px;">
      <div
        class="burger burger-squeeze"
        class:open={navActive}
        on:click={() => (navActive = !navActive)}
      >
        <div class="burger-lines" />
      </div>
      <span>{$usersStore.loggedInUser.userName}</span>
      <img alt="plaatje" src="/img/avatar.jpg" class="ml-1 mr-0 avatar" />
      <a on:click={logout} class="mr-3" id="logout">
        <img
          alt="logout"
          class="logout"
          src="/css/assets/icons/box-arrow-right.svg"
        />
      </a>
    </div>
  </div>
</nav>
<nav id="menu" class:open={navActive}>
  <div class="container">
    <ul>
      <li class="mb-0"><strong class="text-uppercase">algemeen</strong></li>

      <!-- <li class="mb-0">
        <strong class="text-uppercase">import / export</strong>
      </li> -->
      <!-- {#if hasAnyOfRoles($usersStore.loggedInUser.roles, 'ADMINISTRATOR')} -->
      <li>
        <a
          class="pl-3 pr-3"
          href="/app/countries"
          use:link
          on:click={() => (navActive = false)}>countries</a
        >
      </li>
      <li>
        <a
          class="pl-3 pr-3"
          href="/app/langtexts"
          use:link
          on:click={() => (navActive = false)}>language texts</a
        >
      </li>
      <li>
        <a
          class="pl-3 pr-3"
          href="/app/users"
          use:link
          on:click={() => (navActive = false)}>admin users</a
        >
      </li>
      <li>
        <a
          class="pl-3 pr-3"
          href="/app/langs"
          use:link
          on:click={() => (navActive = false)}>languages</a
        >
      </li>
      <!-- {/if} -->
    </ul>
  </div>
</nav>

<style>
  a {
    cursor: pointer;
  }
  .systemInfo {
    border-radius: 10px;
    padding-left: 5px;
    padding-right: 5px;
    font-weight: bold;
    line-height: 30px;
    height: 100%;
  }
</style>
